import React from "react";
import { useMediaQuery } from "react-responsive";
import { Provider as JotaiProvider } from "jotai";
import { PerfilPageWeb } from "./componentes";
import { useValidarUrl } from "hooks";
const PerfilPage = () => {
	const esMovil = useMediaQuery({ query: "(max-width: 860px)" });
	const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });

	const { } = useValidarUrl();

	return (
		<JotaiProvider>
			{/* {esMovil} */}
			{esDesktop && <PerfilPageWeb />}
		</JotaiProvider>
	);
};
export default PerfilPage;
